import React from "react";
import logo from "../../img/logo-02.png";
import { Link } from "react-router-dom";
import { MyContext } from "../../context";
import { useState, useContext } from "react";

function ClientTicket() {
  const { LinkSelection, updateLinkSelection, updateInstallationLinkSelection, updateMyTicket } = useContext(MyContext);
  const active = "sidebarListItem active";
  const notActive = "sidebarListItem ";

  const MyTickets = ()=>{
    updateInstallationLinkSelection("Myticket")
    updateLinkSelection("Myticket")
    updateMyTicket("")
    //Ticket
  }

  return (
    <>
      <div className="sidebar" style={{marginTop: "-25px"}}>
        <div className="sidebarWrapper">
          <div className="sidebarMenu" style={{marginTop:"-22px !important"}}>
            <span className="sideLogo">
              <Link to="/home" className="">
                <img
                  src={logo}
                  className="logo"
                  style={{ margin: "0 auto", width: "70px" }}
                  alt="Login"
                />
              </Link>
            </span>

            <ul className="sidebarList">
              <span onClick={() => updateLinkSelection("")}>
                {" "}
                <li className={LinkSelection === "" ? active : notActive}>
                  <span class="material-symbols-rounded icon">dashboard</span>
                  <span>Overview</span>
                </li>
              </span>

              <span onClick={() => MyTickets()}>
                {" "}
                <li
                  className={LinkSelection === "Myticket" ? active : notActive}
                >
                  <span class="material-symbols-rounded icon">Person</span>
                  <span>My Tickets</span>
                </li>
              </span>
              {/* 
              <span onClick={() => updateLinkSelection("Battery")}>
                <li
                  className={LinkSelection === "Battery" ? active : notActive}
                >
                  <span class="material-symbols-rounded icon">
                    battery_charging_20
                  </span>
                  <span>Battery</span>
                </li>
              </span>
              */}
              <span onClick={() => updateLinkSelection("Report")}>
                {" "}
             {/*  <li className={LinkSelection === "Report" ? active : notActive}>
                <span class="material-symbols-rounded icon">Report</span>
                <span>Report</span>
              </li>*/}
              </span>

              <p className="dashboard_title sideTitle">Account</p>
              <hr />

              <span onClick={() => updateLinkSelection("Setting")}>
                {" "}
              <li className={LinkSelection === "Setting" ? active : notActive}>
                <span class="material-symbols-rounded icon">settings</span>
                <span>Setting</span>
              </li>
              </span>

            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClientTicket;




